// extracted by mini-css-extract-plugin
export default {"formOneLine":"PricelistForm_formOneLine__6ipND"};